<template>
    <div>
      <!-- PASSWORD GATE -->
      <div v-if="!isAuthenticated" class="experience-container password-container">
        <h1>enter password</h1>
        <p class="password-p">
          Enter the password from my resume, or
          <a href="" class="password-contact-link" @click.prevent="showContact">get in touch</a>
          if you need access.
        </p>
        <div class="password-input-container">
          <label class="form-label password-label">
            <input
              v-model="enteredPassword"
              class="contact-input password"
              name="password"
              @keyup.enter="checkPassword"
            >
          </label>
          <button @click="checkPassword" type="submit">submit</button>
        </div>
        <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
      </div>

      <!-- PROJECTS SECTION -->
      <div v-else class="experience-container projects-experience-container">
        <h1 class="experience-h1">some recent projects I've worked on...</h1>

        <div class="projects-grid">

          <div class="project-card" @click="showPlanLibraryProjectLarge">
            <div class="project-card-inner">
              <div class="project-card-header">
                <div class="project-card-tag">Enterprise UX Design · Ecosystem Workflow</div>
                <div class="project-card-company">Paradigm</div>
              </div>
              <h2 class="project-card-title">Plan Library</h2>
              <p class="project-card-desc">An enterprise plan management system used by homebuilders and sales reps.</p>
              <div class="project-card-visual dashboard-visual" style="max-height: 210px;">
                <img src="../assets/plan-lib-community.png" alt="Plan Library" class="project-card-img-fill"/>
              </div>
              <button class="project-button experience-project-button" @click.stop="showPlanLibraryProject">read the story</button>
            </div>
          </div>

                    <!-- 1. myBLDR Search (new) -->
          <div class="project-card" @click="showSearchLarge">
            <div class="project-card-inner">
              <div class="project-card-header">
                <div class="project-card-tag">UX Design · Research</div>
                <div class="project-card-company">Paradigm</div>
              </div>
              <h2 class="project-card-title">myBLDR Semantic Search</h2>
              <p class="project-card-desc">A unified search and AI chat interface for finding anything across a complex enterprise platform.</p>
              <div class="project-card-visual search-visual">
                <div class="search-bar-mock">
                    <svg width="14" height="14" viewBox="0 0 20 20" fill="none"><circle cx="8" cy="8" r="5.5" stroke="#4a7c59" stroke-width="2"/><line x1="12" y1="12" x2="17" y2="17" stroke="#4a7c59" stroke-width="2" stroke-linecap="round"/></svg>
                    <span>Search or ask anything</span>
                </div>
                <div class="search-pills">
                    <span class="search-pill active">All</span>
                    <span class="search-pill">AI Mode</span>
                </div>
                <div class="search-result-rows">
                    <div class="search-result-row"><span class="result-type">Project</span><span class="result-name">Aberdeen Lot 89</span></div>
                    <div class="search-result-row"><span class="result-type">Quote</span><span class="result-name">Window Quote 2</span></div>
                    <div class="search-result-row"><span class="result-type">Customer</span><span class="result-name">Hargrove Homes</span></div>
                </div>
              </div>
              <button class="project-button experience-project-button" @click.stop="showSearch">read the story</button>
            </div>
          </div>

          <!-- 2. myBLDR Quote Dashboard -->
          <div class="project-card" @click="showDashboardProjectLarge">
            <div class="project-card-inner">
              <div class="project-card-header">
                <div class="project-card-tag">UX Design · Data Visualization</div>
                <div class="project-card-company">Paradigm</div>
              </div>
              <h2 class="project-card-title">myBLDR Quote Dashboard</h2>
              <p class="project-card-desc">A redesigned quote management dashboard with AI-powered insights and unified search for sales reps managing thousands of quotes.</p>
              <div class="project-card-visual dashboard-visual">
                <img src="../assets/dashboard.png" alt="Quote Dashboard" class="project-card-img-fill"/>
              </div>
              <button class="project-button experience-project-button" @click.stop="showDashboardProject">read the story</button>
            </div>
          </div>

          <!-- 3. Scanzy -->
          <div class="project-card" @click="showScanzyLarge">
            <div class="project-card-inner">
              <div class="project-card-header">
                <div class="project-card-tag">Brand · Web · Mobile</div>
                <div class="project-card-company">InventoryLab</div>
              </div>
              <h2 class="project-card-title">Scanzy SDK</h2>
              <p class="project-card-desc">Brand identity, marketing website, and mobile demo app for an AI-powered barcode scanning SDK. Grew from zero to 16,000 users in year one.</p>
              <div class="project-card-visual scanzy-visual">
                <img src="../assets/scanzy.png" alt="Scanzy Logo" class="project-card-logo"/>
                <div class="scanzy-phone-row">
                    <img src="../assets/phone-angle.png" alt="Scanzy App" class="project-card-phone"/>
                    <img src="../assets/phone-dark.png" alt="Scanzy App Dark" class="project-card-phone"/>
                </div>
              </div>
              <button class="project-button experience-project-button" @click.stop="showScanzy">read the story</button>
            </div>
          </div>

          <!-- 4. InventoryLab -->
          <!-- <div class="project-card" @click="showInventorylabLarge">
            <div class="project-card-inner">
              <div class="project-card-header">
                <div class="project-card-tag">UX Design · Mobile</div>
                <div class="project-card-company">InventoryLab</div>
              </div>
              <h2 class="project-card-title">InventoryLab Product Alerts</h2>
              <p class="project-card-desc">A mobile alerting system helping Amazon sellers catch pricing and inventory issues before they cost money.</p>
              <div class="project-card-visual il-visual">
                <img src="../assets/mybldr.png" alt="InventoryLab" class="project-card-img-contain"/>
              </div>
              <button class="project-button" @click.stop="showInventorylab">read the story</button>
            </div>
          </div> -->

        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ExperiencePage',
  data() {
    return {
      enteredPassword: '',
      isAuthenticated: false,
      errorMessage: ''
    }
  },
  mounted() {
    const savedAuth = localStorage.getItem('authenticated');
    if (savedAuth === 'true') {
      this.isAuthenticated = true;
    }
  },
  methods: {
    checkPassword() {
      if (this.enteredPassword === 'coffee45') {
        this.isAuthenticated = true;
        localStorage.setItem('authenticated', 'true');
      } else {
        this.errorMessage = 'Incorrect password. Please try again.';
      }
    },
    showScanzy() { this.$emit('show-scanzy'); },
    showInventorylab() { this.$emit('show-inventorylab'); },
    showDashboardProject() { this.$emit('show-dashboard-project'); },
    showSearch() { this.$emit('show-search'); },
    showPlanLibraryProject() { this.$emit('show-plan-library-project'); },
    showScanzyLarge() {
      if (window.innerWidth >= 651) this.$emit('show-scanzy');
    },
    showInventorylabLarge() {
      if (window.innerWidth >= 651) this.$emit('show-inventorylab');
    },
    showDashboardProjectLarge() {
      if (window.innerWidth >= 651) this.$emit('show-dashboard-project');
    },
    showSearchLarge() {
      if (window.innerWidth >= 651) this.$emit('show-search');
    },
    showPlanLibraryProjectLarge() {
      if (window.innerWidth >= 651) this.$emit('show-plan-library-project');
    },
    showContact() { this.$emit('show-contact'); }
  }
}
</script>

<style scoped>
.error {
  color: #8a130b;
  margin-top: 0.5rem;
}

/* ===== GRID ===== */
.projects-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 8px;
}

/* ===== CARD ===== */
.project-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e4e0d8;
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow 0.2s, transform 0.2s;
}
.project-card:hover {
  box-shadow: 0 8px 28px rgba(0,0,0,0.10);
  background: #f3f3f3;;
  /* transform: translateY(-2px); */
}
.project-card-inner {
  padding: 22px 22px 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  box-sizing: border-box;
}
.project-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
}
.project-card-tag {
  font-size: 14px;
  font-weight: 600;
  color: #4a7c59;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.project-card-company {
  font-size: 14px;
  color: #787878;
  font-weight: 500;
}
.project-card-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.25;
}
.project-card-desc {
  font-size: 16px;
  color: #545454;
  line-height: 1.55;
  margin: 0;
}

/* ===== VISUAL AREAS ===== */
.project-card-visual {
  border-radius: 8px;
  overflow: hidden;
  margin: 8px 0 4px;
  flex: 1;
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Search card visual */
.search-visual {
  background: #f8f7f3;
  flex-direction: column;
  padding: 14px;
  gap: 10px;
  align-items: stretch;
}
.search-bar-mock {
  background: white;
  border: 1.5px solid #d4d0c8;
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #aaa;
}
.search-pills {
  display: flex;
  gap: 6px;
}
.search-pill {
  font-size: 11px;
  padding: 3px 10px;
  border-radius: 12px;
  background: #e8e5de;
  color: #666;
  font-weight: 500;
}
.search-pill.active {
  background: #4a7c59;
  color: white;
}
.search-result-rows {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.search-result-row {
  background: white;
  border-radius: 6px;
  padding: 6px 10px;
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 12px;
}
.result-type {
  font-size: 10px;
  font-weight: 600;
  color: #4a7c59;
  background: #eef3f0;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;
}
.result-name {
  color: #333;
  font-weight: 500;
}

/* Dashboard card visual */
.dashboard-visual {
  background: #f0f0f0;
}
.project-card-img-fill {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Scanzy card visual */
.scanzy-visual {
  background: #f8f4ee;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
}
.project-card-logo {
  width: 110px;
  object-fit: contain;
}
.scanzy-phone-row {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.project-card-phone {
  height: 70px;
  object-fit: contain;
}

/* IL card visual */
.il-visual {
  background: #f8f7f3;
}
.project-card-img-contain {
  width: 70%;
  object-fit: contain;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 650px) {
  .projects-grid {
    grid-template-columns: 1fr;
  }
}
</style>